import { observer } from "mobx-react";
import { Box } from "@mui/material";
import BlackCardTitle from "../typographies/BlackCardTitle";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import BlackCardInfo from "../typographies/BlackCardInto";
import { useStoreContext } from "../..";
import LatestLabel from "./details/LastestLabel";
import { useEffect } from "react";
import VaccinationList from "./details/VaccinationList";
import SummaryFrame from "./details/SummaryFrame";
import SummaryContent from "./details/SummaryContent";

const VaccinationSummary = observer(() => {
  const { measurementStore, fieldStore } = useStoreContext();

  useEffect(() => {
    if (!measurementStore.vaccinations) {
      measurementStore.getVaccinations();
    }
  }, [measurementStore.vaccinations]);

  const dataReady = measurementStore.vaccinations && fieldStore.mappedVaccines;
  const latestVaccinations = measurementStore.latestVaccinations;

  return (
    <SummaryFrame>
      <Box className="flex-row-center-start">
        <VaccinesIcon sx={{ color: "black", marginRight: "4px" }} />
        <BlackCardTitle text="Vaccination" />
      </Box>
      <LatestLabel dark />
      <SummaryContent>
        {dataReady && latestVaccinations.length === 0 && (
          <BlackCardInfo text="Inga registreringar" />
        )}
        {dataReady && latestVaccinations.length > 0 && (
          <VaccinationList items={latestVaccinations} />
        )}
      </SummaryContent>
    </SummaryFrame>
  );
});

export default VaccinationSummary;
